import { FC } from 'react'

import { useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components'

import { AdCampaignStrategyEnum } from 'src/Redux/ad-campaignApi'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { ArtistRoutesEnum } from 'src/Router/ArtistComponentsNewUI'
import { capitalizeFirstLetter } from 'src/Helpers/layoutHelpers'
import { Breadcrumb, BreadCrumbItem } from 'src/Components/Breadcrumb'
import { NAVIGATE_BACK_INDEX } from 'src/Constants/constants'

import { SearchTrackForm } from './SearchTrackForm/SearchTrackForm'
import { SearchPlaylistForm } from './SearchPlaylistForm/SearchPlaylistForm'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  max-width: 960px;

  gap: 40px;
  @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
    gap: 16px;
  }
`

export const SearchResourceAdsCampaign: FC = () => {
  const { strategy } = useParams<{ strategy: AdCampaignStrategyEnum }>()
  const navigate = useNavigate()
  const items: BreadCrumbItem[] = [
    {
      title: 'Campaigns',
      path: ArtistRoutesEnum.CampaignsList,
    },
    {
      title: 'Campaign type',
      path: ArtistRoutesEnum.ChooseCreateCampaignPlatform,
    },
    {
      title: 'Strategy type',
      path: ArtistRoutesEnum.CreateAds,
    },
    {
      title: `${capitalizeFirstLetter(strategy)} search`,
      path: '',
    },
  ]

  const onBreadcrumbButtonClick = (): void => {
    navigate(NAVIGATE_BACK_INDEX)
  }
  return (
    <Container>
      <Breadcrumb items={items} onButtonClick={onBreadcrumbButtonClick} />
      {strategy === AdCampaignStrategyEnum.PLAYLIST && <SearchPlaylistForm />}
      {strategy === AdCampaignStrategyEnum.TRACK && <SearchTrackForm />}
    </Container>
  )
}
